import { createQueryKeys } from "@lukemorales/query-key-factory";
import type { QueryKey } from "@tanstack/react-query";

import type { Service } from "../service";

import { i18nQueryKey, withI18nQueryKey } from "~/shared/tanstack-query";

const SERVICE_CATEGORY = "serviceCategory";
const CREATE = "create";
const UPDATE = "update";
const DELETE = "delete";
const GET = "get";
const GET_ALL = "getAll";
const GET_PAGINATED = "getPaginated";

const MUTATION_KEYS = {
  [CREATE]: [SERVICE_CATEGORY, CREATE],
  [UPDATE]: [SERVICE_CATEGORY, UPDATE],
  [DELETE]: [SERVICE_CATEGORY, DELETE],
} as const satisfies Record<string, QueryKey>;

const QUERY_KEYS = createQueryKeys(SERVICE_CATEGORY, {
  [GET]: (params: Parameters<Service[typeof GET]>[0], locale: string) =>
    withI18nQueryKey([params], {
      locale,
    }),
  [GET_ALL]: (locale: string) =>
    i18nQueryKey({
      locale,
    }),
  [GET_PAGINATED]: (params: Parameters<Service[typeof GET_PAGINATED]>[0], locale: string) =>
    withI18nQueryKey([params], { locale }),
});

export { CREATE, DELETE, GET, GET_ALL, GET_PAGINATED, MUTATION_KEYS, QUERY_KEYS, UPDATE };
